// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// Lodash
import { each } from 'lodash-es';
// CRUD
import { QueryResultsModel, HttpExtenstionsModel } from '../../_base/crud';
// State
import { PatientHeightsState } from '../_reducers/patient-height.reducers';
import { PatientHeightModel } from '../_models/patient-height.model';

export const selectPatientHeightsState =
  createFeatureSelector<PatientHeightsState>('patientHeights');

export const selectPatientHeightById = (patientHeightId: number) =>
  createSelector(
    selectPatientHeightsState,
    (patientHeightsState) => patientHeightsState.entities[patientHeightId],
  );

export const selectPatientHeightsPageLoading = createSelector(
  selectPatientHeightsState,
  (patientHeightsState) => patientHeightsState.listLoading,
);

export const selectPatientHeightsActionLoading = createSelector(
  selectPatientHeightsState,
  (patientHeightsState) => patientHeightsState.actionsloading,
);

export const selectLastCreatedPatientHeightId = createSelector(
  selectPatientHeightsState,
  (patientHeightsState) => patientHeightsState.lastCreatedPatientHeightId,
);

export const selectPatientHeightErrorState = createSelector(
  selectPatientHeightsState,
  (patientHeightsState) => patientHeightsState.error,
);

export const selectPatientHeightsShowInitWaitingMessage = createSelector(
  selectPatientHeightsState,
  (patientHeightsState) => patientHeightsState.showInitWaitingMessage,
);

export const selectPatientHeightsInStore = createSelector(
  selectPatientHeightsState,
  (patientHeightsState) => {
    const items: PatientHeightModel[] = [];
    each(patientHeightsState.entities, (element) => {
      items.push(element);
    });
    const httpExtension = new HttpExtenstionsModel();
    const result: PatientHeightModel[] = httpExtension.sortArray(
      items,
      patientHeightsState.lastQuery.sortField,
      patientHeightsState.lastQuery.sortOrder,
    );
    return new QueryResultsModel(result, patientHeightsState.totalCount);
  },
);
